import { makeStyles } from "@mui/styles";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  TableCell,
  Tooltip,
} from "@mui/material";
import {
  Cancel,
  Check,
  CopyAll,
  Create,
  Delete,
  Email,
  PictureAsPdf,
  Receipt,
  Restore,
  WhatsApp,
} from "@mui/icons-material";
import React, { memo, useContext } from "react";
import { withRouter } from "react-router";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import { tienePermisoRuta } from "../../../../config/validaciones";
import AuthContext from "../../../../Context/Auth/AuthContext";
import MenuContext from "../../../../Context/Menu/MenuContext";
import { FechaExacta, permisoDenagado } from "../../../../config/const";
import clienteAxios from "../../../../config/axios";
import { useState } from "react";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import { ModalContactoPlantillaW } from "../../../components/Modal/ModalContactoPlantillaW";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const ButtonsAction = (props) => {
  const {
    arrayExport,
    setarrayExport,
    campoExport,
    row,
    setopenConfirmDialog,
    funcionEdit,
    ocultarEditar,
    ocultarDelete,
    mostrarEstado,
    campoEstado,
    editar,
    funcCancel,
    funcSubmit,
    botonDisabled,
    puedeExportar,
    desdeOtroLugar,
    seteditarFactura,
    changeObjetoActivoStateFactura,
    setopenFactura,
    ObjectoActivoFactura,
    funcionCopiar,
    setopenModalEmail,
    eliminadoEstado,
  } = props;

  const classes = useRowStyles();
  const { usuario } = useContext(AuthContext);
  const { rows } = useContext(MenuContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  const [openConfirmDialogPDF, setopenConfirmDialogPDF] = useState(false);

  const [
    openModalContactoPlantillaW,
    setopenModalContactoPlantillaW,
  ] = useState(false);
  const contactoDefault = {
    medioComunicacion: "Whatsapp",
    option: "Peluqueria",
    idRegistro: row.pelId,
    contacto: [],
    contenidoMensaje: "",
  };
  const [newContacto, setNewContacto] = useState(contactoDefault);

  return (
    <>
      {openModalContactoPlantillaW && (
        <ModalContactoPlantillaW
          personaId={row.pelPerId}
          encabezado={[
            { label: "Documento Propietario:", value: row.pelPerDocNumero },
            {
              label: "Propietario:",
              value: row.pelPerNombre,
            },
            {
              label: "Paciente:",
              value: row.pelMascNombre,
            },
            {
              label: "#Carnet:",
              value: row.pelMascId,
            },
          ]}
          row={row}
          open={openModalContactoPlantillaW}
          setopen={setopenModalContactoPlantillaW}
          newContacto={newContacto}
          setNewContacto={setNewContacto}
          contactoDefault={contactoDefault}
          objetoPlantilla={"empPlantillaPeluqueria"}
        />
      )}
      <ConfirmacionDialog
        open={openConfirmDialogPDF}
        setopen={setopenConfirmDialogPDF}
        titulo={`El tiempo de impresión de esta peluqueria expiró, ¿le gustaría crear una copia?`}
        botones={[
          {
            tooltip: "Crear una copia",
            texto: "SI",
            funcion: () => {
              setopenConfirmDialogPDF(false);
              funcionCopiar();
            },
            disabled: false,
            Icon: CopyAll,
            color: "success",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenConfirmDialogPDF(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "error",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      {arrayExport ? (
        <TableCell
          size="small"
          padding="checkbox"
          style={{
            borderRight: "1px solid #ccc",
            maxWidth: "1rem",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <FormControlLabel
              className={classes.margin}
              control={
                <Checkbox
                  size="small"
                  disabled={!puedeExportar && desdeOtroLugar}
                  className={classes.margin}
                  checked={arrayExport.some((item) => {
                    return item[campoExport] === row[campoExport];
                  })}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setarrayExport([
                        ...arrayExport,
                        { [campoExport]: row[campoExport] },
                      ]);
                    } else {
                      setarrayExport(
                        arrayExport.filter(
                          (item) => item[campoExport] !== row[campoExport]
                        )
                      );
                    }
                  }}
                  color="secondary"
                />
              }
            />
          </Box>
        </TableCell>
      ) : null}
      <TableCell padding="none" style={{ borderRight: "1px solid #ccc" }}>
        <Box display="flex" alignItems="center">
          {eliminadoEstado ? (
            <>
              <Tooltip title="Restaurar" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    if (
                      !tienePermisoRuta(
                        rows,
                        props.location.pathname,
                        usuario.rol,
                        "editar"
                      )
                    ) {
                      return mostrarAlerta(permisoDenagado, "error");
                    }
                    funcionEdit();
                  }}
                >
                  <Restore color="success" />
                </IconButton>
              </Tooltip>
              <Tooltip title="PDF" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    if (
                      usuario.rucempresa === "MEDIPET" &&
                      row.pelFecha !== FechaExacta
                    ) {
                      return setopenConfirmDialogPDF(true);
                    }
                    // Abres la nueva ventas
                    window.open(
                      `https://sysvet.neitor.com/reportes/peluqueria.php?id=${row.pelId}&empresa=${row.pelEmpresa}`,
                      "_blank"
                    );
                  }}
                >
                  <PictureAsPdf color="error" />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <>
              <>
                {editar ? (
                  <>
                    <IconButton
                      className={classes.margin}
                      onClick={() => {
                        funcCancel();
                      }}
                    >
                      <Cancel fontSize="small" color="secondary" />
                    </IconButton>
                    <IconButton
                      className={classes.margin}
                      disabled={botonDisabled ? botonDisabled() : false}
                      onClick={() => {
                        funcSubmit();
                      }}
                    >
                      <Check
                        fontSize="small"
                        color={
                          botonDisabled
                            ? botonDisabled()
                              ? "inherit"
                              : "secondary"
                            : "secondary"
                        }
                      />
                    </IconButton>
                  </>
                ) : (
                  <>
                    {ocultarDelete ? null : (
                      <IconButton
                        className={classes.margin}
                        onClick={() => {
                          if (
                            !tienePermisoRuta(
                              rows,
                              props.location.pathname,
                              usuario.rol,
                              "eliminar"
                            )
                          ) {
                            return mostrarAlerta(permisoDenagado, "error");
                          }
                          setopenConfirmDialog(true);
                        }}
                      >
                        <Delete fontSize="small" color="error" />
                      </IconButton>
                    )}
                    {ocultarEditar ? null : (
                      <IconButton
                        className={classes.margin}
                        onClick={() => {
                          if (
                            !tienePermisoRuta(
                              rows,
                              props.location.pathname,
                              usuario.rol,
                              "editar"
                            )
                          ) {
                            return mostrarAlerta(permisoDenagado, "error");
                          }
                          funcionEdit();
                        }}
                      >
                        <Create color="secondary" />
                      </IconButton>
                    )}
                  </>
                )}
              </>
              {mostrarEstado ? (
                <FormControlLabel
                  disabled
                  className={classes.margin}
                  control={
                    <Checkbox
                      value="ACTIVO"
                      className={classes.margin}
                      checked={
                        row[campoEstado] === "ACTIVA" ||
                        row[campoEstado] === "ACTIVO"
                          ? true
                          : false
                      }
                      color="primary"
                    />
                  }
                />
              ) : null}
              <Tooltip title="PDF" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    if (
                      usuario.rucempresa === "MEDIPET" &&
                      Date.parse(row.pelFecha) < Date.parse(FechaExacta)
                    ) {
                      return setopenConfirmDialogPDF(true);
                    }
                    // Abres la nueva ventas
                    window.open(
                      `https://sysvet.neitor.com/reportes/peluqueria.php?id=${row.pelId}&empresa=${row.pelEmpresa}`,
                      "_blank"
                    );
                  }}
                >
                  <PictureAsPdf color="error" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Copiar" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    funcionCopiar();
                  }}
                >
                  <CopyAll color="primary" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Enviar Correos" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    setopenModalEmail(true);
                  }}
                >
                  <Email color="secondary" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Factura" arrow>
                <IconButton
                  className={classes.margin}
                  disabled={row.idFactura === ""}
                  onClick={async () => {
                    // Abres la nueva ventas
                    try {
                      const resProveedor = await clienteAxios(
                        `/proveedores/${row.pelPerId}`
                      );

                      const proveedorF = resProveedor.data.data[0];
                      if (row.idFactura.trim() !== "") {
                        const resFactura = await clienteAxios.get(
                          `/ventas/${row.idFactura}`
                        );

                        seteditarFactura(true);

                        changeObjetoActivoStateFactura({
                          ...resFactura.data.data[0],
                          venOption: "3",
                        });
                        return setopenFactura(true);
                      }
                      changeObjetoActivoStateFactura({
                        ...ObjectoActivoFactura,
                        venIdCliente: proveedorF.perId,
                        venRucCliente: proveedorF.perDocNumero,
                        venTipoDocuCliente: proveedorF.perDocTipo,
                        venNomCliente: proveedorF.perNombre,
                        venEmailCliente: proveedorF.perEmail,
                        venTelfCliente: proveedorF.perTelefono,
                        venCeluCliente: proveedorF.perCelular,
                        venDirCliente: proveedorF.perDireccion,
                        venOption: "1",
                      });
                      setopenFactura(true);
                    } catch (error) {}
                  }}
                >
                  <Receipt
                    color={row.idFactura === "" ? "inherit" : "primary"}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Mensaje whatsapp" arrow>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    setopenModalContactoPlantillaW(true);
                  }}
                >
                  <WhatsApp color="success" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>
      </TableCell>
    </>
  );
};

export default withRouter(memo(ButtonsAction));
